import "../depend/react/jsx-runtime.mjs";
import { exports as s } from "./jsx-runtime2.mjs";
const x = s.Fragment, a = s.jsx, m = s.jsxs;
export {
  x as Fragment,
  a as jsx,
  m as jsxs
};
//# sourceMappingURL=jsx-runtime.mjs.map
